import React from "react"
import Sticky from "react-sticky-el"
import { Action, ActionType } from "@tenforce/toolbox-button-push-react"

import bem from "../../bem"
import { IButtonData } from "./index"

interface OwnProps {
    buttons: IButtonData[]
    isLoading: boolean
    footerClass?: string
    children?: React.ReactNode
}

const b = bem.with("NewUI__footer")

const StickyFooter: React.FC<OwnProps> = (props: OwnProps) => {
    const { buttons, isLoading, footerClass, children } = props
    return (
        <div className={b()}>
            <Sticky
                mode="bottom"
                positionRecheckInterval={1000 / 12}
                className={b("container")}
                topOffset={1}
            >
                <footer className={footerClass || ""}>
                    {buttons.map((button) => {
                        return (
                            <Action
                                key={button.id}
                                actionType={ActionType.button}
                                isTransparent={!button.style.isFilled}
                                isSecondary={!button.style.isPrimaryColor}
                                onClick={button.onClick}
                                isLoading={isLoading}
                            >
                                {button.label}
                            </Action>
                        )
                    })}
                    {children}
                </footer>
            </Sticky>
        </div>
    )
}
export default StickyFooter
